module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/zm-a303f51a36999e85ed3baa54fef73a7a.svg";